import { render } from "./AddDividend.vue?vue&type=template&id=7bc54a21&scoped=true&ts=true"
import script from "./AddDividend.vue?vue&type=script&lang=ts"
export * from "./AddDividend.vue?vue&type=script&lang=ts"

import "./AddDividend.vue?vue&type=style&index=0&id=7bc54a21&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bc54a21"]])

export default __exports__